import React from 'react';
import { RefreshEnabledFeaturesContext } from './refresh-enabled-features-context';

export function useRefreshEnabledFeatures(): () => void {
    const refreshEnabledFeatures = React.useContext(RefreshEnabledFeaturesContext);
    if (!refreshEnabledFeatures) {
        throw new Error('Unexpectedly did not find refreshEnabledFeatures on context.');
    }
    return refreshEnabledFeatures;
}
